export const cus_lange={
    TH:{
        customer_data:"ข้อมูลผู้เสียค่าธรรมเนียม",
        back_to_customer:"กลับไปแสดงข้อมูลผู้เสียค่าธรรมเนียม",
        add_customer:"เพิ่มข้อมูลผู้เสียค่าธรรมเนียม",
        customer_id:"รหัสผู้เสียค่าธรรมเนียม",
        customer_name:"ชื่อผู้เสียค่าธรรมเนียม",
        mobile:"เบอร์โทรศัพท์",
        email:"อีเมล",
        data_fil:"ข้อมูลไม่ครบถ้วน",
        place:"ที่อยู่",
        show_place_detail:"แสดงรายการที่อยู่",
        edit:"แก้ไข",
        delete:"ลบ",
        save_data:"บันทึกข้อมูล",
        add_customer_place:"เพิ่มที่อยู่ของผู้เสียค่าธรรมเนียม",
        place_id:"รหัสที่อยู่",
        place_description:"รายละเอียดที่อยู่",
        place_address:"ที่อยู่",
        create_place_req:"เพิ่มสถานที่จากคำร้อง",
        create_place_not_req:"เพิ่มสถานที่จากจากฟอร์ม",
        tambol:"ตำบล",
        amphur:"อำเภอ",
        province:"จังหวัด",
        place_mobile:"เบอร์โทรศัพท์สถานที่",
        postcode:"รหัสไปรษณีย์",
        remark:"หมายเหตุ",
        place_type_description:"ชนิดสถานที่",
        lat:"ละติจูด",
        lon:"ลองจิจูด",
        back_to_customer_place:"กลับไปหน้าแสดงข้อมูลที่อยู่ของผู้เสียค่าธรรมเนียม",
        choose_position:"เลือกตำแหน่งบนแผนที่",
        clear:"ล้าง",
        alert_place_mobile:"กรุณากรอกเบอร์โทรศัพท์สถานที่",
        alert_customer_name:"กรุณากรอกชื่อผู้เสียค่าธรรมเนียม",
        alert_mobile:"กรุณากรอกเบอร์โทรศัพท์",
        alert_email:"กรุณากรอกอีเมล",
        email_error:"อีเมลต้องมี @ และ .com",
        alert_position:"กรุณาเลือกตำแหน่งนนแผนที่",
        alert_place_description:"กรุณากรอกรายละเอียดที่อยู่",
        alert_place_address:"กรุณากรอกที่อยู่",
        alert_tambol:"กรุณากรอกตำบล",
        alert_amphur:"กรุณากรอกอำเภอ",
        alert_province:"กรุณากรอกจังหวัด",
        alert_remark:"กรุณากรอกหมายเหตุ",
        alert_place_type:"กรุณาเลือกชนิดสถานที่",
        alert_postcode:"กรุณากรอกรหัสไปรษณีย์",
        alert_request_id:"กรุณาเลือกรหัสคำร้อง",

        cant_load_data:"ไม่สามารถดึงข้อมูลได้!",
        alert_load:"เกิดข้อผิดพลาดในการดึงจากฐานข้อมูล",
        no_internet_alert:"กรุณาตรวจสอบการเชื่อมต่ออินเตอร์เน็ตของคุณ",
        cant_save_data:"เกิดข้อผิดพลาดในการบันทึกข้อมูลกรุณาลองใหม่อีกครั้ง",
        saved:"ข้อมูลถูกบันทึกเรียบร้อยแล้ว!",
        confirm_delete:"คุณต้องการลบข้อมูลผู้เสียค่าธรรมเนียมนี้ใช่หรือไม่?",
        warning_delete:"ข้อมูลถูกลบแล้วไม่สามารถย้อนกลับได้!",
        want_delete:"ฉันต้องการลบ",
        close_page:"ปิดหน้านี้",
        deleted:"ข้อมูลถูกลบเรียบร้อยแล้ว!",
        cant_delete:"ไม่สามารถลบข้อมูลได้",
        delete_place_confirm:"คุณต้องการลบข้อมูลที่อยู่ของผู้เสียค่าธรรมเนียมนี้ใช่หรือไม่?",
        search:"ค้นหา",
        place_pic:"รูปภาพสถานที่",
        customer_surname:"สกุล",
        customer_prefix:"คำนำหน้า",
        customer_prosonalcard:"หมายเลขบัตรประชาชน",
        customer_middle_name:"ชื่อกลาง",
        customer_nationality:"เชื้อชาติ",
        customer_race:"สัญชาติ",
        customer_birthday:"วันเกิด",
        alert_customer_surname:"กรุณากรอกสกุล",
        alert_customer_prefix:"กรุณาเลือกคำนำหน้า",
        alert_customer_prosonalcard:"กรุณากรอกหมายเลขบัตรประชาชน",
        alert_customer_middle_name:"กรุณากรอกชื่อกลาง",
        alert_customer_nationality:"กรุณากรอกเชื้อชาติ",
        alert_customer_race:"กรุณากรอกสัญชาติ",
        alert_customer_birthday:"กรุณาเลือกวันเกิด",
        no_image:"ไม่มีรูปแสดง",
        place_owner:"ชื่อเจ้าของบ้าน",

        request_id:"รหัสคำร้อง",
        request_date:"วันที่ยื่นคำร้อง",
        customer_name_request:"ชือ/นามสกุล ผู้ยื่นคำร้อง",
        flag:"สถานะการอนุมัติ",
        remark_request:"ข้อมูลรายละเอียดคำร้อง",
        request_type:"คำร้อง"
    },
    EN:{
        data_fil:"incomplete information",
        customer_data:"customer",
        back_to_customer:"show customer data",
        add_customer:"add customer",
        create_place_req:" Add a place from the request",
        create_place_not_req:"Add a location from from a form.",
        customer_id:"customer ID",
        customer_name:"customer name",
        mobile:"phone number",
        email:"email",
        place:"place",
        show_place_detail:"show place detail",
        edit:"edit",
        delete:"delete",
        save_data:"save data",
        add_customer_place:"add customer place",
        place_id:"place ID",
        place_description:"place description",
        place_address:"place address",
        tambol:"tambol",
        amphur:"amphur",
        province:"province",
        postcode:"postal code",
        place_mobile:"place mobile",
        remark:"remark",
        place_type_description:"place type",
        lat:"latitude",
        lon:"longitude",
        back_to_customer_place:"back to customer place",
        choose_position:"choose position in the map",
        clear:"clear",
        alert_customer_name:"please input customer name",
        alert_mobile:"please input phone number",
        alert_email:"please input email" ,
        email_error:"email must contain '@' and '.com' ",
        alert_position:"please choose the position in the map",
        alert_place_description:"please input place description",
        alert_place_number:"please input the place address",
        alert_tambol:"please input the tambol(Thai)",
        alert_amphur:"please input the amphur(Thai)",
        alert_province:"please input the province(Thai)",
        alert_tambol_en:"please input the tambol(English)",
        alert_amphur_en:"please input the amphur(English)",
        alert_province_en:"please input the province(English)",
        alert_place_mobile:"please input place mobile",
        alert_remark:"please input the remark",
        alert_place_type:"please choose the place type",
        alert_postcode:"please input the postal code",
        alert_request_id:"please choose the request id",

        cant_load_data:"can't load data!",
        alert_load:"Error for loading data",
        no_internet_alert:"please check your internet connection",
        cant_save_data:"error save data please try again",
        saved:"data was saved!",
        confirm_delete:"Are you sure to delete this customer data?",
        warning_delete:"deleted data can't recovery!",
        want_delete:"delete this",
        close_page:"close this page",
        deleted:"data was deleted!",
        cant_delete:"can't delete data!",
        delete_place_confirm:"Are you sure to delete this customer place data?",
        search:"search",
        place_pic:"place picture",

        customer_surname:"surname",
        customer_prefix:"prefix",
        customer_prosonalcard:"customer card",
        customer_middle_name:"middle name",
        customer_nationality:"nationality",
        customer_race:"race",
        customer_birthday:"date of birth",
        alert_customer_surname:"please input surname",
        alert_customer_prefix:"please select prefix",
        alert_customer_prosonalcard:"please input the customer card",
        alert_customer_middle_name:"please input middle name",
        alert_customer_nationality:"please input nationality",
        alert_customer_race:"please input race",
        alert_customer_birthday:"please pick the date of birth",
        no_image:"No image to show",
        place_owner:"place owner",

        request_id:"Request Id",
        request_date:"Request Date",
        customer_name_request:"Customer Name",
        flag:"Status",
        remark_request:"Request Information",
        request_type:"Request"
    }
}
